export const CONTRACT_PATH = "api/contracts";
export const EXTENRAL_CONTRACT_PATH = "api/external/contracts";
export const CONTRACT_BALANCE_PATH = "balance/api/contracts";
